import './Dashboard.scss';
import ListItems from './ListItems';
let listItemsData = [
  { imgSrc: 'https://remitxb2c.s3.ap-south-1.amazonaws.com/1692703397356-folder.png', linkItem: 'listing', name: 'E-sign Document' },
  { imgSrc: 'https://remitxb2c.s3.ap-south-1.amazonaws.com/1692703397269-compress.png', linkItem: 'compressor', name: 'Compressor' },
  { pSym: '₹', linkItem: 'rateadmin', name: 'Rate Admin' },
  { imgSrc: 'https://remitxb2c.s3.ap-south-1.amazonaws.com/1704710276834-calculator.png',linkItem:'ratecalculator',name:'Rate Calculator'},
  { imgSrc: 'https://remitxb2c.s3.ap-south-1.amazonaws.com/1692703397356-folder.png',linkItem:'pancheck',name:'Pan Check'}
];
const Dashboard = ({ user }) => {
  return (
    <>
      <div className="container" id="ourSolutions">
        <h1>Our Solutions</h1>
        <ul className="flex-display">
          {listItemsData.filter(t=>{
            // return t.linkItem == "pancheck" ? ["11166","15220","15470"].includes(user.employee_code) : true
            return t.linkItem
          }).map((item) => (
            <ListItems imgSrc={item?.imgSrc} pSym={item?.pSym} linkItem={item.linkItem} name={item.name} isVisible={item.linkItem !== 'rateadmin' || user?.rateadmin?.isVisible} />
          ))}
        </ul>
      </div>
    </>
  );
};
export default Dashboard;
